import { notifications } from "@mantine/notifications";
import { useEffect, useState, useRef } from "react";
import { getConstellation } from "./graph-structure";
import { getGlyphSlots, postGlyphSlot } from "../../requests/glyphslot";
import { getSkillsDescriptions } from "../../requests/skill";

const useConstellation = ({ defaultConstellation, treeId, quadrantId }) => {
  const [constellation, setConstellation] = useState(defaultConstellation);
  const [skillDescriptions, setSkillDescriptions] = useState(null);
  const [glyphSlots, setGlyphSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const constellationRef = useRef(null);
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
  });

  const saveGlyphSlot = async ({ glyphId }) => {
    let savedSlot = null;
    try {
      savedSlot = await postGlyphSlot({
        treeId: treeId,
        glyphSlot: {
          glyphId,
          quadrantId,
        },
      });
    } catch (err) {
      return;
    }

    notifications.show({
      message: `Saved slot ${savedSlot.glyphId} for ${savedSlot.quadrantId} within tree ${savedSlot.treeId}`,
      color: "green",
    });
    return savedSlot;
  };

  useEffect(() => {
    // Function to update dimensions
    const updateDimensions = () => {
      const update = { ...dimensions };
      if (constellationRef.current) {
        const { offsetWidth, offsetHeight } = constellationRef.current;
        update.width = offsetWidth;
        update.height = offsetHeight;
      }
      setDimensions(update);
    };

    // Update dimensions initially
    updateDimensions();
    // Remove any which existed already
    window.removeEventListener("resize", updateDimensions);
    // Add event listener to update dimensipons on window resize
    window.addEventListener("resize", updateDimensions);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [constellation]);

  useEffect(() => {
    setConstellation(getConstellation(glyphSlots));
    if (glyphSlots?.length) {
      setLoading(false);
    }
  }, [glyphSlots]);

  useEffect(() => {
    getSkillsDescriptions().then(setSkillDescriptions);
    getGlyphSlots({ treeId }).then((_glyphSlots) => {
      setGlyphSlots(_glyphSlots);
      setLoading(false);
    });
  }, []);

  return {
    skillDescriptions,
    constellation,
    setConstellation,
    constellationRef,
    dimensions,
    saveGlyphSlot,
    loading,
  };
};

export default useConstellation;
